"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BaseProviderFormProps } from "@/components/settings/data-providers/provider-forms/base-provider-form";
import { InstructionsWrapper } from "@/components/settings/data-providers/provider-forms/instructions-wrapper";
import { FormInput } from "@/components/ui/input";
import { ProviderType } from "@/types/dataProvider";
export const CallLinksProviderForm = t0 => {
  const $ = _c(12);
  const {
    form,
    isCreating,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li>Your Call Links account is linked to your AppFolio database name.</li>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li>Go to your AppFolio dashboard and observe the URL in your browser (e.g:{" "}<code><u>companyx</u>.appfolio.com</code>).</li>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <code className="italic">.appfolio.com</code>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ol className="">{t2}{t3}<li>The prefix to {t4} is your database name — in this scenario,{" "}<strong><code>companyx</code></strong>.</li></ol>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isEditMode) {
    t6 = <InstructionsWrapper accordion={isEditMode} title="How to find your Database Name:">{t5}</InstructionsWrapper>;
    $[4] = isEditMode;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== form || $[7] !== isCreating) {
    t7 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="Database Name" name="data.credentials.databaseName" placeholder="Enter Database Name (e.g. companyx)" type="text" />;
    $[6] = form;
    $[7] = isCreating;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
(CallLinksProviderForm as any).providerType = ProviderType.CALL_LINKS;